export const getFormattedAndSortedDates = (dates, language, timeZone) => {
  const formatter = new Intl.DateTimeFormat(language, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone,
  })

  return dates
    ?.map(date => ({
      label: formatter.format(new Date(date)),
      value: date,
    }))
    .sort((a, b) => new Date(a.value) - new Date(b.value))
}
